var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCaretSolidRight = function SvgCaretSolidRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    d: "M18.292 10.89c.61.613.61 1.605 0 2.211L7.908 23.54a1.546 1.546 0 0 1-2.2 0 1.57 1.57 0 0 1 0-2.212l9.28-9.33-9.28-9.329a1.565 1.565 0 0 1 0-2.211 1.55 1.55 0 0 1 2.2 0l10.384 10.438z"
  })));
};
export default SvgCaretSolidRight;